// host names:
export const BUY_IT_AGAIN_HOST = 'buyItAgain';
export const ORDER_HISTORY_HOST = 'orderHistory';

// contracts:
export const commonVpDependenciesV1 = {
  swan: { major: 3 },
};
